import angular from "angular";

angular
    .module('app')
    .component('cabinetUserProfile', {
        template: require('./cabinet-user-profile.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', 'moment','trans', controller],
        bindings: {
            user: '<'
        }
    });

function controller($http, ErrorResponseParser, Notifier, moment,trans) {

    let $ctrl = this;

    $ctrl.full_name = null;
    $ctrl.name = null;
    $ctrl.last_name = '';
    $ctrl.phone = null;
    $ctrl.email = null;
    $ctrl.patronymic = null;
    $ctrl.current_password = null;
    $ctrl.password = null;

    $ctrl.$onInit = function () {
        if ($ctrl.user) {
            $ctrl.full_name = $ctrl.user.full_name;
            $ctrl.name = $ctrl.user.name;
            $ctrl.last_name = $ctrl.user.last_name;
            $ctrl.phone = $ctrl.user.phone;
            $ctrl.email = $ctrl.user.email;
            $ctrl.patronymic = $ctrl.user.patronymic;
        }
    };

    $ctrl.submit = function () {

        let params = {
            name: $ctrl.name,
            last_name: $ctrl.last_name,
            phone: $ctrl.phone,
            email: $ctrl.email,
            patronymic: $ctrl.patronymic,
        };

        params['_method'] = 'PUT';

        $http.post(`/cabinet/update-profile`, params).then(
            function (response) {

                Notifier.success(trans('Data updated successfully'), 2);

                $ctrl.full_name = $ctrl.last_name + ' ' + $ctrl.name;
                $ctrl.user.email = $ctrl.email;
                $ctrl.validationErrors = [];
            },

            function (error) {

                if (error.status == 422) {
                    $ctrl.validationErrors = error.data.errors;
                    Notifier.error(trans('Error filling'), 2);
                } else {
                    Notifier.error(trans("An error occurred with the text: :error" , {error:error.data.message}), 2);
                }
            })
    };

    $ctrl.changePassword = function () {
        let params = {
            current_password: $ctrl.current_password,
            password: $ctrl.password,
        };

        params['_method'] = 'PUT';

        $http.post(`/cabinet/change-password`, params).then(
            function (response) {

                Notifier.success(trans('Password updated successfully'), 2);
                $ctrl.current_password = null;
                $ctrl.password = null;
                $ctrl.validationErrors = [];
            },

            function (error) {

                if (error.status == 422) {
                    $ctrl.validationErrors = error.data.errors;
                    Notifier.error(trans('Error filling'), 2);
                } else {
                    Notifier.error(trans("An error occurred with the text: :error" , {error:error.data.message}), 2);
                }
            })
    }


}
